var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "700" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("edit-column")))]),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-card-content" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-value-autocomplete", {
                        attrs: {
                          "known-headers": _vm.allowedOutputHeaders,
                          label: _vm.$ct("winfakt-field"),
                        },
                        model: {
                          value: _vm.column.NewHeaderName,
                          callback: function ($$v) {
                            _vm.$set(_vm.column, "NewHeaderName", $$v)
                          },
                          expression: "column.NewHeaderName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("app-edit-settings", {
                attrs: {
                  "known-headers": _vm.knownHeaders,
                  value: _vm.column.NewValue,
                  label: _vm.$ct("value"),
                },
              }),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }